/** Function to check that the param is the never type */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- we do not need to use the param
export const exhaustiveCheck = (_param: never): never => {
  throw new Error('Looks like there is some incorrect typing.')
}
